import { Permission } from '@insio/shared-types';

/** Whether a person may open the automation settings: whoever may view the rules. */
export function canOpenAutomationSettings(
  hasPermission: (permission: Permission) => boolean
): boolean {
  return hasPermission(Permission.RULES_VIEW);
}
